import useRestaurant from './useRestaurant';

const useGlobalFlags = () => {
  const { globalFlags } = useRestaurant();

  return globalFlags;
};

export default useGlobalFlags;
